const ActionType = {
  EXECUTER_DATA: "VehicleAction.EXECUTER_DATA",
  EXECUTER_VIEW_STATE: "VehicleAction.EXECUTER_VIEW_STATE",
}

export default ActionType
